import React, { useRef, useState } from "react";

// Img
import locationIcon from "../../../assets/svg/contact/ic-location.svg";

// Local
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAP_API_KEY } from "../../../util/helper";
import { Icon, InputField, InputFieldV2 } from "@jds/core";
import { Box } from "@mui/material";

const libraries = ["places"];

export default function LocationInput(props) {
  const [autoCompleteController, setAutoCompleteController] = useState(null);
  const inputRef = useRef();

  // google maps api
  const { isLoaded } = useJsApiLoader({
    // id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries,
  });

  if (!isLoaded) {
    return;
  }

  const onSearchPlace = async () => {
    if (autoCompleteController == null) {
      return;
    }
    const placeDetails = await autoCompleteController.getPlace();

    const place = {
      name: placeDetails?.formatted_address,
      lat: placeDetails?.geometry?.location?.lat(),
      lng: placeDetails?.geometry?.location?.lng(),
    };
    props?.onLocationSelect?.(place);
  };
  return (
    <Autocomplete
      onLoad={(data) => setAutoCompleteController(data)}
      onPlaceChanged={onSearchPlace}
    >
      <Box
        sx={{
          "& .input_label-jds-text": { fontSize: "14px" },
          "& .j-JDSInputField-input-container": { paddingRight: "10px" },
          "& ..j-JDSInputField-input_label-jds-text": { paddingLeft: "unset" },
        }}
      >
        <InputField
          ref={inputRef}
          placeholder=""
          label="Event Location"
          suffix={
            <Icon
              ic={
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
                  <path
                    d="M8 0.000191801C5.93261 -0.0482109 3.93021 0.724249 2.43094 2.14855C0.931675 3.57286 0.0576113 5.53304 0 7.60019C0 12.6802 5.91 18.7402 6.59 19.4102C6.96473 19.7827 7.47163 19.9918 8 19.9918C8.52837 19.9918 9.03527 19.7827 9.41 19.4102C10.09 18.7402 16 12.6802 16 7.60019C15.9424 5.53304 15.0683 3.57286 13.5691 2.14855C12.0698 0.724249 10.0674 -0.0482109 8 0.000191801ZM8 11.0002C7.40666 11.0002 6.82664 10.8242 6.33329 10.4946C5.83994 10.165 5.45542 9.69642 5.22836 9.14824C5.0013 8.60006 4.94189 7.99686 5.05764 7.41492C5.1734 6.83298 5.45912 6.29843 5.87868 5.87887C6.29824 5.45931 6.83279 5.17359 7.41473 5.05784C7.99667 4.94208 8.59987 5.00149 9.14805 5.22855C9.69623 5.45562 10.1648 5.84013 10.4944 6.33348C10.8241 6.82683 11 7.40685 11 8.00019C11 8.79584 10.6839 9.5589 10.1213 10.1215C9.55871 10.6841 8.79565 11.0002 8 11.0002Z"
                    fill="var(--color-primary-60)"
                  />
                </svg>
              }
            />
            // <Icon ic={"IcLocation"} color="success" />
          }
          {...props}
        />
      </Box>
    </Autocomplete>
  );
}
